<template>
    <div class="hs-container">
        <div class="handle-box">
            <div class="handle-left">
                <el-select v-model="query.company_id" filterable multiple collapse-tags clearable placeholder="选择公司" class="handle-select mr10" style="width: 14rem">
                    <el-option v-for="(row, index) in dictionary.getPicker('company')" :key="index" :label="row.title" :value="row.id"></el-option>
                </el-select>
                <el-select v-model="query.date_type" placeholder="时间类型" class="handle-select mr10" style="width:6.5rem;">
                    <el-option key="event_date" label="举办日期" value="event_date"></el-option>
                    <el-option key="sign_date" label="签单日期" value="sign_date"></el-option>
                    <el-option key="create_time" label="创建日期" value="create_time"></el-option>
                </el-select>
                <el-date-picker class="daterange mr10" v-model="query.range" type="daterange" align="right" unlink-panels range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions" value-format="yyyy-MM-dd"></el-date-picker>
                <el-button type="primary" icon="el-icon-search" @click="getTableData">搜索</el-button>
                <el-button type="primary" icon="el-icon-download" @click="exportExcel">导出</el-button>
            </div>
        </div>
        <el-table id="out-table" :data="tableData" :height="tableHeight" border class="table" ref="multipleTable" header-cell-class-name="table-header" v-loading="loading">
            <el-table-column type="index" width="60" align="center" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="contract_no" show-overflow-tooltip label="合同编号"></el-table-column>
            <el-table-column prop="company" label="签单公司" width="120" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="news_type" label="订单类型" width="100" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="cooperation_mode" show-overflow-tooltip label="合作模式"></el-table-column>
            <el-table-column prop="bridegroom" label="客户姓名" align="center" width="160" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="hotel" label="酒店" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="event_date" label="举办日期" width="120" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="sign_date" label="签单日期" width="120" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="totals" label="合同总额" align="center" width="120" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="cost_totals" label="总消金额" align="center" width="120" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="append_totals" label="增项金额" align="center" width="120" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="income_totals" label="已收款项" align="center" width="120" :show-overflow-tooltip="true"></el-table-column>
        </el-table>
    </div>
</template>

<script>

import fileSaver from 'file-saver';
import xlsx from 'xlsx';
import dictionary from '@/utils/dictionary.js';
export default {
    data() {
        let tableHeight = window.innerHeight - 217
        return {
            loading: false,
            query: {
                company_id: [], // 签单公司, 可多选
                date_type: '', // 检索的的时间类型
                range: [], // 时间区间
            },
            tableData: [], // 表格数据
            tableHeight: tableHeight, // 表格高度
            pickerOptions: {
                shortcuts: [{
                    text: '最近一周',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start, end]);
                    }
                },
                {
                    text: '最近一个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', [start, end]);
                    }
                },
                {
                    text: '最近三个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                        picker.$emit('pick', [start, end]);
                    }
                }
                ]
            }
        };
    },
    beforeMount() {
        this.dictionary = dictionary;
    },
    methods: {
        getTableData() {
            let that = this;
            let url = '/api/statistics.order/cost';
            let query = that.query;
            that.loading = true;
            this.$post(url, query).then(function (response) {
                let result = response.data;
                that.tableData = result.list;
                that.loading = false;
            });
        },
        // 导出表格
        exportExcel() {
            /* 从表生成工作簿对象 */
            var wb = xlsx.utils.table_to_book(document.querySelector('#out-table'));
            /* 获取二进制字符串作为输出 */
            var wbout = xlsx.write(wb, {
                bookType: 'xlsx',
                bookSST: true,
                type: 'array'
            });
            try {
                fileSaver.saveAs(
                    //Blob 对象表示一个不可变、原始数据的类文件对象。
                    //Blob 表示的不一定是JavaScript原生格式的数据。
                    //File 接口基于Blob，继承了 blob 的功能并将其扩展使其支持用户系统上的文件。
                    //返回一个新创建的 Blob 对象，其内容由参数中给定的数组串联组成。
                    new Blob([wbout], {
                        type: 'application/octet-stream'
                    }),
                    //设置导出文件名称
                    '消费统计.xlsx'
                );
            } catch (e) { }
            return wbout;
        }
    }
};
</script>

<style lang="less">
@import url('./common.css');
</style>
